import * as helpers from '../helpers';

export default function buttonsStateToggle() {
    const iconToggleElements = [].slice.call(document.querySelectorAll('[data-toggle-icon]'));
    const textToggleElements = [].slice.call(document.querySelectorAll('[data-toggle-text]'));

    if (iconToggleElements !== null) {
        iconToggleElements.forEach((toggleElem) => {
            const defaultLoadIcon = toggleElem.className;
            const stateClass = toggleElem.getAttribute('data-toggle-class');

            if (stateClass && helpers.hasClass(toggleElem, stateClass)) {
                toggleElem.innerText = toggleElem.getAttribute('data-toggle-icon');
                toggleElem.setAttribute('data-toggle-icon', defaultLoadIcon);
            }

            toggleElem.addEventListener('click', () => {
                const defaultIcon = toggleElem.className;
                toggleElem.className = toggleElem.getAttribute('data-toggle-icon');
                toggleElem.setAttribute('data-toggle-icon', defaultIcon);
            });
        });
    }

    if (textToggleElements !== null) {
        textToggleElements.forEach((toggleElem) => {
            const defaultLoadText = toggleElem.innerText;
            const stateClass = toggleElem.getAttribute('data-toggle-class');

            if (stateClass && helpers.hasClass(toggleElem, stateClass)) {
                toggleElem.innerText = toggleElem.getAttribute('data-toggle-text');
                toggleElem.setAttribute('data-toggle-text', defaultLoadText);
            }

            toggleElem.addEventListener('click', () => {
                const defaultText = toggleElem.innerText;
                toggleElem.innerText = toggleElem.getAttribute('data-toggle-text');
                toggleElem.setAttribute('data-toggle-text', defaultText);
            });
        });
    }
}
